import { z } from 'zod'
import {
  GeoJSONFeatureSchema,
  GeoJSONFeatureCollectionSchema,
  GeoJSONGeometrySchema,
  GeoJSONMultiPolygonSchema,
  GeoJSONMultiLineStringSchema,
  GeoJSONMultiPointSchema,
  GeoJSONPolygonSchema,
  GeoJSONLineStringSchema,
  GeoJSONPointSchema,
} from 'zod-geojson'

/**
 * Tipos de geometrias básicas do GeoJSON
 */
export const point = () => GeoJSONPointSchema.describe('Ponto')
export const lineString = () => GeoJSONLineStringSchema.describe('Linha')
export const polygon = () => GeoJSONPolygonSchema.describe('Polígono')
export const multiPoint = () => GeoJSONMultiPointSchema.describe('Multiponto')
export const multiLineString = () => GeoJSONMultiLineStringSchema.describe('Multilinha')
export const multiPolygon = () => GeoJSONMultiPolygonSchema.describe('Multipolígono')
export const geometry = () => GeoJSONGeometrySchema.describe('Qualquer geometria')

/**
 * Features GeoJSON genéricas
 */
export const anyFeature = () => GeoJSONFeatureSchema.describe('Qualquer item geográfico')
export const anyFeatureCollection = () =>
  GeoJSONFeatureCollectionSchema.describe('Coleção de itens geográficos')

/**
 * Features GeoJSON com geometria e propriedades específicas
 */
export const feature = (geometry: z.ZodType, properties: z.ZodType = z.object({}).nullish()) =>
  z.object({
    type: z.literal('Feature'),
    geometry,
    properties,
  })
export const featureCollection = (
  geometry: z.ZodType,
  properties: z.ZodType = z.object({}).nullish(),
) =>
  z.object({
    type: z.literal('FeatureCollection'),
    features: z.array(
      z.object({
        type: z.literal('Feature'),
        geometry,
        properties,
      }),
    ),
  })

/**
 * União de todos os tipos GeoJSON possíveis
 *
 * @deprecated Use os tipos específicos acima ao invés deste tipo genérico
 */
export const geoJson = () =>
  z
    .union([
      GeoJSONPointSchema,
      GeoJSONLineStringSchema,
      GeoJSONPolygonSchema,
      GeoJSONMultiPointSchema,
      GeoJSONMultiLineStringSchema,
      GeoJSONMultiPolygonSchema,
      GeoJSONFeatureSchema,
      GeoJSONFeatureCollectionSchema,
      GeoJSONGeometrySchema,
    ])
    .describe('Qualquer representação GeoJSON')

export const latitude = () =>
  z
    .union([z.number(), z.string()])
    .refine(val => Number(val) >= -90 && Number(val) <= 90)
    .transform(value => Number(value))

export const longitude = () =>
  z
    .union([z.number(), z.string()])
    .refine(val => Number(val) >= -180 && Number(val) <= 180)
    .transform(value => Number(value))
